import Config from "config";

export class HelpHelper {
    public getHelpUrl(culture: string, routeName: string, top: boolean): string {
        culture = culture.replace("-", "_");
        const flareDirectory = this.getFlareDirectory(routeName);
        const baseHelpUrl = Config.helpUrlMobile;

        if (flareDirectory.toLowerCase().includes("home")) {
            return baseHelpUrl.replace("[culture]", culture).replace("[flareId]", "HOME");
        }
        if (top) {
            return baseHelpUrl.replace("[culture]", culture).replace("[flareId]", flareDirectory + "/" + flareDirectory);
        }
        
        return baseHelpUrl.replace("[culture]", culture).replace("[flareId]", flareDirectory + "/" + this.getFlareHelpPage(routeName));
    }

    private getFlareDirectory(routeName: string): string {
        return routeName.split("_", 1)[0];
    }

    private getFlareHelpPage(routeName: string): string {
        const helpPage = routeName.split("_");
        if (helpPage.length > 1) {
            let firstPart: string;
            let remainingParts: string[];
            [firstPart, ...remainingParts] = routeName.split("_");
            return remainingParts.join("_");
        }
        return helpPage[0];
    }
}
